import { StockInStoreListComponent } from './stock-in-store-list.component';

export default StockInStoreListComponent;
